module.exports = __webpack_public_path__ + "img/mogilogo.0c0e1f81.png";